// this is still in progress; not done yet.
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require("react");
var DataSourceSelect_1 = require("./DataSourceSelect");
var EntityTypeSelect_1 = require("./EntityTypeSelect");
var Xref = (function (_super) {
    __extends(Xref, _super);
    function Xref(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            organism: props.organism,
            entityType: props.entityType,
            dataSource: props.dataSource,
            identifier: props.identifier,
        };
        return _this;
    }
    Xref.prototype.render = function () {
        var that = this;
        that.handleEntityTypeUpdate = function (entityType) {
            that.setState({ entityType: entityType });
        };
        that.handleDataSourceUpdate = function (dataSource) {
            that.setState({ dataSource: dataSource });
        };
        var entityTypeSelectStyle = {
            float: 'left'
        };
        var dataSourceSelectStyle = {
            float: 'left'
        };
        var identifierStyle = {
            float: 'left'
        };
        return React.createElement("div", null,
            React.createElement(EntityTypeSelect_1.WPEntityTypeSelect, { style: entityTypeSelectStyle, entityType: that.state.entityType, updateHandler: that.handleEntityTypeUpdate }),
            React.createElement(DataSourceSelect_1.DataSourceSelect, { style: dataSourceSelectStyle, organism: that.state.organism, entityType: that.state.entityType, dataSource: that.state.dataSource, updateHandler: that.handleDataSourceUpdate }),
            React.createElement("span", { style: identifierStyle },
                React.createElement("input", { value: that.state.identifier, onChange: function (e) {
                        that.setState({ identifier: e.currentTarget.value });
                    } })),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", null,
                "props: ",
                JSON.stringify(that.props)),
            React.createElement("br", null),
            React.createElement("div", null,
                "state: ",
                JSON.stringify(that.state)));
    };
    return Xref;
}(React.Component));
exports.Xref = Xref;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/components/Xref.js
// module id = 242
// module chunks = 0